import { phoneNumberSchema } from '@/lib/phone-number-schema';
import { z } from '@holistic/components';

/** Mesaj alanının karakter sınırı; sayaç da bu değeri gösterir. */
export const MESSAGE_MAX_LENGTH = 500;

export const sendMailSchema = z.object({
  name: z.string().min(1, 'Ad soyad zorunludur'),

  email: z
    .string()
    .min(1, 'E-posta zorunludur')
    .email('Geçerli bir e-posta adresi giriniz'),

  phone: phoneNumberSchema,

  topic: z.string().min(1, 'Konu seçimi zorunludur'),

  message: z
    .string()
    .min(1, 'Mesaj boş olamaz')
    .min(10, 'Mesaj en az 10 karakter olmalıdır')
    .max(MESSAGE_MAX_LENGTH, `Mesaj en fazla ${MESSAGE_MAX_LENGTH} karakter`),

  // Checkbox varsayılan olarak false başlar; literal(true) yerine refine ile
  // doğrulanıyor ki formun defaultValues tipi boolean kalabilsin.
  kvkk: z.boolean().refine((v) => v, 'Devam etmek için onay vermelisiniz'),
});

export type SendMailSchema = z.infer<typeof sendMailSchema>;
